import React, { useState, useEffect } from "react";
import { Box, Button, Typography, Stepper, Menu, MenuItem } from "@mui/material";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import StepperComponent from "./StepperComponent/StepperComponent";
import OtpValidation from "./OtpValidation/OtpValidation";
import SignInForm from './SignInForm';
import { step1ValidationSchema, step2ValidationSchema } from './../../utils/validation';
import LanguageDropdown from "./LanguageDropdown/LanguageDropdown";
import { useLanguage } from "../../context/LanguageContext/LanguageContext";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import { useDispatch, useSelector } from "react-redux";
import ReviewPage from "./ReviewPage/ReviewPage";
import ForgetPassword from "./ForgetPassword/ForgetPassword";
import { requestNewCustomer } from "../../redux/slices/customerSlice";
import { resendEmailVerification } from '../../redux/slices/resendEmailVerification';
import { confirmOTP } from "../../redux/slices/otpSlice";
import { useNavigate } from "react-router";
import FormTitle from "./FormTitle";
import { Link } from 'react-router-dom';
import { fetchPhoneNumber, selectPhoneNumber } from '../../redux/slices/phoneNumberSlice';
import { validateCustomerMainData } from "../../redux/slices/ValidateCustomerMainData";
const ReusableForm = ({ formType, onToggle }) => {
    const navigate = useNavigate();
    const [Forgetstep, setForgetstep] = useState(1);
    // Callback to update step when ForgetPassword component is submitted
    const handleStepChange = (newStep) => {
        setForgetstep(newStep);
    };
    const { translations, language, direction } = useLanguage();
    const t = translations;
    const [step, setStep] = useState(1);
    const [selectedLanguage, setSelectedLanguage] = useState("English");
    const [showForgetPassword, setShowForgetPassword] = useState(false);
    const supportedFileTypes = ["image/jpeg", "image/png", "image/gif", "video/mp4", "application/pdf", "application/vnd.adobe.photoshop", "application/psd"];
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    useEffect(() => {
        if (errorMessage) {
            const timer = setTimeout(() => {
                setErrorMessage(""); // Clear the error message
            }, 3000); // 3 seconds

            return () => clearTimeout(timer); // Cleanup the timer if the component unmounts or errorMessage changes
        }
    }, [errorMessage]);
    const [formData, setFormData] = useState({
        phone: "",
        name: "",
        idNumber: "",
        email: "",
        city: '',
        district: '',
        project: '',
        building: '',
        floor: '',
        unit: '',
        uploadedFiles,
        equipments: [
            {
                equipmentNameAr: "",
                equipmentNameEn: "",
                descriptionAr: "",
                descriptionEn: "",
                floorFk: 0, // Set the initial floorFk based on your form logic
            },
        ],
    });
    const validationSchemas = {
        1: step1ValidationSchema(t),
        2: step2ValidationSchema(t),
    };
    const formik = useFormik({
        initialValues: {
            phone: "",
            name: "",
            idNumber: "",
            email: "",
            city: "",
            district: "",
            project: "",
            building: "",
            floor: "",
            unit: "",
            step: 1,
            equipments: [
                {
                    equipmentNameAr: "",
                    equipmentNameEn: "",
                    descriptionAr: "",
                    descriptionEn: "",
                    floorFk: 0,
                },
            ],
        },
        validationSchema: validationSchemas[step],
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: (values) => {

        },
    });

    const [openModal, setOpenModal] = useState(false);

    React.useEffect(() => {
        formik.setFieldValue("step", step);
    }, [step]);
    const validateStep = async (currentStep) => {
        const errors = await formik.validateForm(); // Validate all fields
        let fieldsToValidate = [];

        // Define fields for each step
        if (currentStep === 1) {
            fieldsToValidate = ["phone", "name", "idNumber", "email"];
        } else if (currentStep === 2) {
            fieldsToValidate = ["city", "district", "project", "building", "floor", "unit"];

            // Check for specific validation for step 2
            if (!formik.values.building || !formik.values.floor) {
                formik.setFieldError("building", "Building cannot be empty");
                formik.setFieldError("floor", "Floor cannot be empty");
            }
        } else if (currentStep === 3) {
            fieldsToValidate = ["unit", "equipments"];
        }

        // Mark fields in the current step as touched to show errors
        formik.setTouched(
            fieldsToValidate.reduce((acc, key) => ({ ...acc, [key]: true }), {})
        );

        // Check if any of the fields have errors
        const hasErrors = fieldsToValidate.some((key) => errors[key]);

        return !hasErrors; 
    };

    const handleStepClick = async (stepIndex) => {
        if (stepIndex + 1 < step) {
            // Backward navigation: No validation required
            setStep(stepIndex + 1);
            return;
        }

        // Validate all steps leading up to the target step
        for (let i = 1; i <= stepIndex + 1; i++) {
            const isValid = await validateStep(i);
            if (!isValid) {
                // console.log(`Step ${i} has errors. Fix them before proceeding.`);
                return; // Stop navigation if any step is invalid
            }
        }

        // All validations passed; proceed to the next step
        setStep(stepIndex + 1);
    };

    // Update Formik `step` field whenever the current step changes
    React.useEffect(() => {
        formik.setFieldValue("step", step);
    }, [step]);



    const customHandleChange = (e) => {
        const { name, value } = e.target;
        // Update Formik's state
        formik.setFieldValue(name, value);
        // Update the external state
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const dispatch = useDispatch();
    const phoneNumberData = useSelector(selectPhoneNumber);

    useEffect(() => {
        dispatch(fetchPhoneNumber()); // Fetch phone number on mount
    }, [dispatch]);
    const validationResult = useSelector((state) => state.customer.validationResult); // Access validation result from the store

    // Extract phone number (if available)
    const phoneNumber = phoneNumberData.find((item) => item.WebisteLinkType === 8)?.Value || 'No phone number available';
    const finalData = {
        CustomerName: formData.name || formik.values.name,
        PhoneNumber: formData.phone || formik.values.phone,
        TaxId: formData.idNumber || formik.values.idNumber,
        email: formData.email || formik.values.email,
        // attachmentBase64: uploadedFiles[0].base64, 
        // attachmentFileName: uploadedFiles[0].name,             
    };
    const handleNext = () => {
        if (step === 1) {
            const fieldsToValidate = ["phone", "name", "idNumber", "email"];
            formik.validateForm().then((errors) => {
                const hasErrors = fieldsToValidate.some((key) => errors[key]);
                if (hasErrors) {
                    formik.setTouched(fieldsToValidate.reduce((acc, key) => ({ ...acc, [key]: true }), {}));
                } else {
                       // Before going to next step, validate customer main data
                const customerData = {
                    customerName: formik.values.name || formData.name,
                    phoneNumber: formik.values.phone || formData.phone,
                    taxId: formik.values.idNumber || formData.idNumber,
                    language: language === "English" ? "2" : "1",
                  
                };
                
                dispatch(validateCustomerMainData(customerData))
                .unwrap()
                .then((response) => {
                
                    
                    if (response.successtate === 200) {
                        // Proceed to next step
                        setStep(step + 1);
                    } else if (response.successtate === 305) {
                        // Handle already registered user
                        setStep(1);
                        setErrorMessage(response.errormessage || "This account has already been registered.");
                    } else if (response.successtate === 333) {
                        
                        setOtpData({
                            customerName: formik.values.name || formData.name,
                            taxId: formik.values.idNumber || formData.idNumber,
                            phoneNumber: formik.values.phone || formData.phone,
                            otpMessage: response.message || "Please verify your email",
                        });
                        dispatch(resendEmailVerification({customerName:formik.values.name || formData.name, phoneNumber:formik.values.phone || formData.phone, taxId:formik.values.idNumber || formData.idNumber}))
                        .unwrap()
                        .then((data) => {
                            if (data.successtate === 200) {

                                setStep(4);
                                setOtpData({
                                    customerName: formData.name || formik.values.name,
                                    taxId: formData.idNumber || formik.values.idNumber,
                                    phoneNumber: formData.phone || formik.values.phone,
                                    otpMessage: data.message
                                });


                            } else {
                                console.error("Failed to resend email:", data.errormessage);
                            }
                        })
                        .catch((error) => {
                            console.error("Error during resend email verification:", error);
                        });
                } else {
                        setErrorMessage(response.errormessage || "An unexpected error occurred.");
                    }
                })
                .catch((error) => {
                    console.error("Validation failed:", error);
                    setErrorMessage("An error occurred while validating the customer.");
                });
        }
    });} else if (step === 2) {
            const fieldsToValidate = ["city", "district", "project"];
            formik.validateForm().then((errors) => {
                const hasErrors = fieldsToValidate.some((key) => errors[key]);
                if (hasErrors) {
                    formik.setTouched(fieldsToValidate.reduce((acc, key) => ({ ...acc, [key]: true }), {}));
                } else {
                    setStep(step + 1);
                }
            });
        } else if (step === 3) {


            // Conditionally add attachment fields if a file exists
            if (uploadedFiles && uploadedFiles.length > 0) {
                finalData.attachmentBase64 = uploadedFiles[0].base64;
                finalData.attachmentFileName = uploadedFiles[0].name;
            }



            if (
                formData.equipments &&
                formData.equipments.length > 0 &&
                formData.equipments.some(
                    (equipment) =>
                        equipment.equipmentNameAr ||
                        equipment.equipmentNameEn ||
                        equipment.descriptionAr ||
                        equipment.descriptionEn ||
                        equipment.floorFk !== 0
                )

            ) {
                // Only send `equipments` if at least one equipment has valid data
                finalData.equipments = formData.equipments;
            } else if (formik.values.unit) {
                // Send `EquipmentIds` if a unit is selected
                finalData.EquipmentIds = [parseInt(formik.values.unit, 10)];

            }
            // console.log("fd",finalData);
            dispatch(requestNewCustomer({finalData,language}))
                .unwrap()
                .then((response) => {
                 
                    if (response.successtate === 200) {
                        // console.log("Registration Successful:", response);
                        setStep(step + 1);  // Move to the next step (OTP validation)
                        // Pass relevant data to OTP validation
                        setOtpData({
                            customerName: formData.name || formik.values.name,
                            taxId: formData.idNumber || formik.values.idNumber,
                            phoneNumber: formData.phone || formik.values.phone,
                            otpMessage: response.message
                        });
                    }
                    if (response.successtate === 305) {
                        setStep(1);
                        setErrorMessage(response.errormessage || "هذا الحساب تم تسجيلة من قبل");

                    }
                    if (response.successtate === 304) {
                        setStep(step - 1);
                        setErrorMessage(response.errormessage || "This unit is already assigned to another customer.");
                        // errormessage: 'تم تخصيص هذه الوحدة من قبل لعميل آخر'
                        // console.log("error", response.errormessage);
                    }
                    if (response.successtate === 333) {
                        dispatch(resendEmailVerification({customerName:finalData.CustomerName, phoneNumber:finalData.PhoneNumber, taxId:finalData.TaxId}))
                            .unwrap()
                            .then((data) => {
                                if (data.successtate === 200) {

                                    setStep(4);
                                    setOtpData({
                                        customerName: formData.name || formik.values.name,
                                        taxId: formData.idNumber || formik.values.idNumber,
                                        phoneNumber: formData.phone || formik.values.phone,
                                        otpMessage: data.message
                                    });


                                } else {
                                    console.error("Failed to resend email:", data.errormessage);
                                }
                            })
                            .catch((error) => {
                                console.error("Error during resend email verification:", error);
                            });
                    } else if (response.successtate === 301) {
                        // Handle successtate 301
                        // console.log("Error:", response.errormessage);
                        setErrorMessage(response.errormessage || "A unit with these details already exists.");
                        setStep(step - 1); // Go back to the previous step
                    } else {
                        // console.log("Unexpected error:", response);
                        // setErrorMessage(response.errormessage || "An unexpected error occurred. Please try again.");
                    }
                })
                .catch((error) => {
                    console.error("Registration Failed:", error);
                    // setErrorMessage(response.errormessage || "An unexpected error occurred. Please try again.");

                });
        }
    };
    const handleBack = () => {
        if (step > 1) {
            setStep((prevStep) => prevStep - 1);
        }
    };
    const [dragActive, setDragActive] = useState(false);
    const [otpData, setOtpData] = useState([]);
    const handleConfirm = async (verificationCode) => {
        // Destructure otpData to access customerName, taxId, and phoneNumber
        const { customerName, taxId, phoneNumber } = otpData;
        const otpDataToSend = {
            customerName,
            taxId,
            phoneNumber,
            verificationCode,
        };

        try {
            const response = await dispatch(confirmOTP(otpDataToSend)).unwrap();
            if (response.successtate === 200) {
                setStep(5);
            } else if (response.successtate === 306) {
                setErrorMessage(response.errormessage || "Invalid verification code.");
                console.error("Error:", response.errormessage);
            }
            else if (response.successtate === 309) {

                setErrorMessage(response.errormessage || "Invalid verification code.");
                console.error("Error:", response.errormessage);
            }

        } catch (error) {
            // This block handles errors related to the request, such as network errors or server issues
            console.error("Confirmation Failed:", error);

            // Check if the error has a response, such as from the API
            if (error.response) {
                setErrorMessage(error.response.data.errorMessage || "Error from server: " + error.response.status);
            } else {
                setErrorMessage(error.message || "An error occurred during the process.");
            }
        }
    };
    // Handle drag events
    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);

        const droppedFiles = e.dataTransfer.files;

        if (droppedFiles && droppedFiles.length > 0) {
            // Convert dropped files to an array
            const validFiles = Array.from(droppedFiles);

            // Prevent adding duplicate files by comparing both name and size
            const newFiles = validFiles.filter((file) =>
                !uploadedFiles.some(
                    (uploadedFile) =>
                        uploadedFile.attachmentFileName === file.name &&
                        uploadedFile.size === file.size
                )
            );

            // Filter out unsupported files (if you have a supportedFileTypes array)
            const unsupportedFiles = newFiles.filter(
                (file) => !supportedFileTypes.includes(file.type)
            );

            if (unsupportedFiles.length > 0) {
                // Optionally show an alert or message for unsupported files
                // console.log("Some files are unsupported.");
            }

            if (newFiles.length > 0) {
                // Convert each file to Base64 and store it alongside the name and type
                const filesWithBase64 = newFiles.map((file) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    return new Promise((resolve) => {
                        reader.onloadend = () => {
                            // Resolving object with Base64 encoded data and file details
                            resolve({
                                base64: reader.result,
                                name: file.name,
                                type: file.type,
                            });
                        };
                    });
                });

                Promise.all(filesWithBase64).then((newFilesData) => {
                    setUploadedFiles((prev) => [...prev, ...newFilesData]);
                });
            }
        }
    };

    // Handle file selection via browse button
    const handleFileSelect = (e) => {
        if (e.target.files && e.target.files[0]) {
            setUploadedFiles((prev) => [...prev, ...e.target.files]);
        }
    };
    // Remove a file from the uploaded list
    const removeFile = (index) => {
        setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
    };
    const handleOpenUnit = () => {
        setOpenModal(true); // Open the modal when the button is clicked
    };
    // Close modal function
    const handleCloseUnit = () => {
        setOpenModal(false); // Close the modal
    };

    return (
        <Box
            sx={{
                maxWidth: "600px",
                margin: "auto",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
            }}
        >
            {/* Language Dropdown */}
            <LanguageDropdown
                selectedLanguage={selectedLanguage}
                setSelectedLanguage={setSelectedLanguage}
            />
            <FormTitle formType={formType} Forgetstep={Forgetstep} step={step} t={t} />



            {/* Stepper */}
            {formType === "signup" && (step !== 4 && step !== 5) && (
                <StepperComponent steps={[t.personal, t.location, t.other]}
                    activeStep={step - 1}
                    formType={formType}
                    direction={direction} onStepClick={handleStepClick} />

            )}
            <form onSubmit={formik.handleSubmit}>
                {errorMessage && (
                    <Box sx={{ mb: 2, marginTop: 2, padding: 2, backgroundColor: 'error.main', color: 'white', borderRadius: 1 }}>
                        <Typography variant="body1">{errorMessage}</Typography>
                    </Box>
                )}
                {/* Conditional Fields for Sign Up Steps */}
                {formType === "signup" && step === 1 && (
                    <Step1 formik={formik} customHandleChange={customHandleChange} handleNext={handleNext} t={t} direction={direction} />
                )}

                {/* Conditional Fields for Sign Up Steps */}
                {formType === "signup" && step === 2 && (
                    <>
                        {/* {errorMessage && (
                            <Box sx={{ marginTop: 2, padding: 2, backgroundColor: 'error.main', color: 'white', borderRadius: 1 }}>
                                <Typography variant="body1">{errorMessage}</Typography>
                            </Box>
                        )} */}
                        <Step2 formik={formik} handleNext={handleNext}
                            handleBack={handleBack} customHandleChange={customHandleChange}
                            openModal={openModal} handleOpenUnit={handleOpenUnit}
                            handleCloseUnit={handleCloseUnit}
                            formData={formData}
                            setFormData={setFormData}
                            t={t}
                            language={language}
                            direction={direction}

                        />
                    </>
                )}

                {/* Step 3: Location Specific Information */}
                {formType === "signup" && step === 3 && (


                    <Step3
                        uploadedFiles={uploadedFiles}
                        setUploadedFiles={setUploadedFiles}
                        handleNext={handleNext}
                        handleBack={handleBack}
                        handleDrag={handleDrag}
                        handleDrop={handleDrop}
                        handleFileSelect={handleFileSelect}
                        removeFile={removeFile}
                        direction={direction}
                        t={t}
                    />

                )}
                {/* Step 3: Location Specific Information */}
                {formType === "signup" && step === 4 && (
                    <OtpValidation
                        handleConfirm={handleConfirm}
                        handleBack={handleBack}
                        direction={direction}
                        t={t}
                        customerName={otpData.customerName}
                        taxId={otpData.taxId}
                        phoneNumber={otpData.phoneNumber}
                        otpMessage={otpData.otpMessage}
                        phoneNumberSupport={phoneNumber}
                        formData={finalData}
                    />
                )}
                {formType === "signup" && step === 5 && (
                    <ReviewPage t={t} phoneNumber={phoneNumber} />

                )}
                {/* Fields common to both Sign In and Sign Up */}
                {formType === "signin" && (
                    <SignInForm
                        onForgotPassword={() => {
                            setShowForgetPassword(true); // Show ForgetPassword form
                            navigate("/forget-password"); // Update URL to reflect ForgetPassword form
                        }}
                        formik={formik}
                        customHandleChange={customHandleChange}
                        t={t}
                        direction={direction}
                    />
                )}
                {formType === "forget-password" && <ForgetPassword
                    step={Forgetstep}
                    setStep={handleStepChange}
                    direction={direction}
                    t={t}
                    onBack={() => {
                        setShowForgetPassword(false); // Switch back to SignInForm
                        // navigate("/signin"); // Update URL to reflect SignIn form
                    }} // Switch back to SignInForm
                />}

                {/* Toggle between forms */}

                {formType !== "forget-password" && (
                    <Typography

                        sx={{ textAlign: "center", mt: 2, color: "#797979", fontWeight: 500, fontSize: "16px", mb: 8 }}
                    >
                        {formType === "signin" && step !== 4 ? (
                            <>
                                {t.noAccount}{" "}
                                <Link
                                    to="/signup"
                                    onClick={onToggle}
                                    style={{ color: "#0C2A92", fontWeight: 700, textDecoration: "none" }}
                                >
                                    {t.signUp}
                                </Link>
                            </>
                        ) : formType === "signup" && (step !== 4 && step !== 5) ? (
                            <>
                                {t.alreadyAccount}{" "}
                                <Link
                                    to="/signin"
                                    onClick={onToggle}
                                    style={{ color: "#0C2A92", fontWeight: 700, textDecoration: "none" }}
                                >
                                    {t.signIn}
                                </Link>
                            </>
                        ) : null}

                    </Typography>
                )
                }

            </form>
        </Box>
    );
};

export default ReusableForm;
